import classNames from 'classnames';
import { FC } from 'react';
import { useAppDispatch, useAppSelector } from 'src/app/hooks';
import { changeTheme } from 'src/store/actions/authActions';
import { Theme } from 'src/store/models/Auth';

import Switch from '../Switch/Switch';
import classes from './ThemeSwitch.module.scss';

export const ThemeSwitch: FC = () => {
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.auth.user);
  const isDarkTheme = user?.settings?.theme === Theme.DARK;

  return (
    <Switch
      checked={isDarkTheme}
      handleChange={(_, checked) =>
        dispatch(changeTheme(checked ? Theme.DARK : Theme.LIGHT))
      }
      width={60}
      height={30}
      borderWidth={3}
      className={classNames(classes.ThemeSwitch, {
        [classes.Dark]: isDarkTheme,
      })}
    />
  );
};
